import { STORAGE_ITEMS } from '~/hooks/use-remote-storage/storage-keys';
import {
  FeatureFlags,
  Flags,
} from '~/stores/use-feature-flags/feature-flags.types';

export const mapItemsToFeatureFlags = (
  items: STORAGE_ITEMS
): Flags | undefined => {
  if (typeof items.feature_flags !== 'object') {
    return undefined;
  }

  return items.feature_flags as Record<FeatureFlags, boolean>;
};
